import React, { useContext } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import { RootStoreContext } from 'index';

import styles from './DeclineMdaDialog.module.scss';

interface DeclineMdaDialogPropsType {
  changeDialogStep: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

const DeclineMdaDialog = ({ changeDialogStep, setIsOpen }: DeclineMdaDialogPropsType) => {
  const { intermediaryApplicationsStore } = useContext(RootStoreContext);
  const handeDecline = async () => {
    await intermediaryApplicationsStore.declineMasterDialerAgreement();
    setIsOpen(false);
  };

  return (
    <>
      <p className={styles.informationalText}>
        Choosing to cancel the HFS Master Dealer Agreement will prevent you and your business from using the HFS Home
        Improvement Loan Platform.
      </p>
      <p className={styles.title}>Are you sure you want to cancel?</p>
      <Button className={styles.button} onClick={() => changeDialogStep()}>
        No, go Back
      </Button>
      <Button
        className={styles.frameButton}
        onClick={handeDecline}
        variant="white"
        isLoading={intermediaryApplicationsStore.isMasterDialerAgreementLoading}
      >
        Yes, cancel
      </Button>
    </>
  );
};

export default observer(DeclineMdaDialog);
